export default {
  hasDashboard: false,
  isFixed: true,
  slug: "dashboard",
  display: false,
  menus: []
};